/* hs-eslint ignored failing-rules */
/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */

'use es6';

import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import FormattedList from 'I18n/components/FormattedList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { getDynamicNamespace } from 'conversations-infrastructure/i18n/getDynamicNamespace';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { SYSTEM_RULES, MANUAL_SPAM, MANUAL_BLOCK, MANUAL, autoConfigurableRules } from 'conversations-thread-data/thread-details/public/constants';
import { getAllowDenyListSettingsUrl } from '../../urls/getAllowDenyListSettingsUrl';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const filterThreadAlerts = [SYSTEM_RULES, MANUAL_SPAM, MANUAL_BLOCK, MANUAL];
const mapSpamRuleToFormattedMessage = rule => {
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    options: {
      href: getAllowDenyListSettingsUrl(),
      target: 'blank'
    },
    elements: {
      Link
    },
    message: getDynamicNamespace({
      translationOptions: autoConfigurableRules,
      prefix: 'conversations-thread-view.spam-filtering-and-blocking.SpamThreadAlert.text.systemRules.multiple_jsx'
    }, rule)
  }, rule);
};
const MutipleSpamRulesString = ({
  triggeredSpamRules
}) => {
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "conversations-thread-view.spam-filtering-and-blocking.SpamThreadAlert.text.systemRules.multiplePrefix",
    options: {
      multipleRules: /*#__PURE__*/_jsx(FormattedList, {
        children: triggeredSpamRules.map(mapSpamRuleToFormattedMessage)
      })
    }
  });
};
const SingleRuleString = ({
  triggeredSpamRules
}) => {
  const reasonFlagged = triggeredSpamRules.first();
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    options: {
      href: getAllowDenyListSettingsUrl(),
      target: 'blank'
    },
    elements: {
      Link
    },
    message: getDynamicNamespace({
      translationOptions: triggeredSpamRules,
      defaultOption: 'default',
      prefix: 'conversations-thread-view.spam-filtering-and-blocking.SpamThreadAlert.text.systemRules.single_jsx'
    }, reasonFlagged)
  });
};
const SpamReasonString = ({
  triggeredSpamRules
}) => {
  if (triggeredSpamRules.size < 1) {
    return null;
  }
  return triggeredSpamRules.size > 1 ? /*#__PURE__*/_jsx(MutipleSpamRulesString, {
    triggeredSpamRules: triggeredSpamRules
  }) : /*#__PURE__*/_jsx(SingleRuleString, {
    triggeredSpamRules: triggeredSpamRules
  });
};
const SpamReason = ({
  source,
  triggeredSpamRules,
  isLoading = false
}) => {
  if (isLoading) {
    const loadingMessage = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-thread-view.spam-filtering-and-blocking.SpamThreadAlert.text.loadingFilterRulesMessage"
    });
    return /*#__PURE__*/_jsx(View, {
      inlineSize: "100%",
      margin: "0",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        label: loadingMessage,
        showLabel: true,
        size: "extra-small",
        margin: "100"
      })
    });
  }
  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx("strong", {
      children: source !== SYSTEM_RULES ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
        options: {
          href: getAllowDenyListSettingsUrl(),
          target: 'blank'
        },
        elements: {
          Link
        },
        message: getDynamicNamespace({
          translationOptions: filterThreadAlerts,
          defaultOption: 'MANUAL',
          prefix: 'conversations-thread-view.spam-filtering-and-blocking.SpamThreadAlert.text.manual_jsx'
        }, source)
      }) : /*#__PURE__*/_jsx(SpamReasonString, {
        triggeredSpamRules: triggeredSpamRules
      })
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-thread-view.spam-filtering-and-blocking.SpamThreadAlert.text.commonDeletedAfter90Days"
    })]
  });
};
SpamReason.displayName = 'SpamReason';
SpamReason.propTypes = {
  source: PropTypes.string.isRequired,
  triggeredSpamRules: ImmutablePropTypes.listOf(PropTypes.string),
  isLoading: PropTypes.bool
};
export default SpamReason;